import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BusinessRestServices from '../../services/business-rest.service';
import Config from '../../utils/config.service';
import DialogServices from '../../services/dialog.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { ModalTrainingProgramSelectionComponent } from '../modal-training-program-selection/modal-training-program-selection.component';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    standalone: true,
    selector: 'table-employee-training-program',
    templateUrl: './table-employee-training-program.component.html',
    imports: [
        CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, TranslatePipe,
        ItemNoContentComponent, LoaderOverlayComponent, FormsModule
    ]
})
export class TableEmployeeTrainingProgramComponent implements OnInit, OnDestroy {
    private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
    private config: Config = inject(Config);
    private dialogServices: DialogServices = inject(DialogServices);
    private session: Session = inject(Session);
    private angularHelperService: AngularHelperService = inject(AngularHelperService);
    private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);

    @Input() pageSize: any | undefined;
    @Input() employees: any;
    @Output() employeesChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() currentPage: any | undefined;
    @Input() trainingProgramCode: any | undefined;
    @Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>();

    searchSubject: Subject<string> = new Subject<string>();
    vm: any = undefined;
    broadcastSubscriptions: Array<Subscription> = [];

    constructor() {
        this.vm = this;

        this.searchSubject.pipe(
            debounceTime(500)
        ).subscribe(() => {
            this.filterByName();
        });
    }

    ngOnInit() {
        this.vm.user = this.session.getSession().user;
        this.vm.filter = {
            orderBy: 'created',
            ascending: false
        };
        this.vm.pageSize = this.vm.pageSize || 10;
        this.vm.currentPage = this.vm.currentPage || 0;
        this.vm.endReached = false;
        this.vm.includeInsurance = false;
        this.vm.loading = false;
        this.vm.employees = [];
        this.vm.employeeSelectionMap = {};
        this.vm.trainingProgramCode = this.trainingProgramCode;

        this.vm.isShowActiveOnly = false;
        this.vm.isAllEmployeesModeEnabled = false;

        this.vm.fetchEmployees = this.fetchEmployees;
        this.vm.updateEmployeeListSelectionMap = this.updateEmployeeListSelectionMap;
        this.vm.getEmployeeStatus = this.getEmployeeStatus;
        this.vm.setFilter = this.setFilter;
        this.vm.openModalTrainingProgramDialog = this.openModalTrainingProgramDialog;

        this.broadcastSubscriptions.push(
            this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
                if (!this.vm.endReached) {
                    this.fetchEmployees(true);
                }
            })
        );

        this.fetchEmployees(true);
    }

    ngOnDestroy() {
        for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
            this.broadcastSubscriptions[b].unsubscribe();
        }
    }

    onSearchChange(searchTerm: string) {
        this.searchSubject.next(searchTerm);
    }

    fetchEmployees(hasLoader?) {
        if (this.vm.endReached) {
            this.vm.loading = false;
            return;
        }
        var params: any = {
            pageSize: this.vm.pageSize * 2,
            start: this.vm.employees.length,
            orderBy: this.vm.filter.orderBy || 'created',
            ascending: this.vm.filter.ascending || false,
            activeAndPendingOnly: true,
            activeOnly: this.vm.isShowActiveOnly
        };
        if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 2) params.name = this.vm.term.trim();

        this.businessRestServices.getWorkers(params, (employees) => {
            if (employees && employees.length < this.vm.pageSize * 2) {
                this.vm.endReached = true;
            }
            if (hasLoader) {
                this.angularHelperService.createTimer(() => {
                    this.vm.loading = false;
                    employees.forEach((employee) => {
                        this.vm.employeeSelectionMap[employee.id] = (this.vm.isAllEmployeesModeEnabled && (this.vm.employeeSelectionMap[employee.id] !== false))
                            || (!this.vm.isAllEmployeesModeEnabled && (this.vm.employeeSelectionMap[employee.id] === true));
                    })
                    this.vm.employees = this.vm.employees.concat(employees);
                    this.employeesChange.emit(this.vm.employees);
                }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
            }
        });
    }

    updateEmployeeListSelectionMap() {
        this.vm.employees.forEach((employee) => {
            this.vm.employeeSelectionMap[employee.id] = this.vm.isAllEmployeesModeEnabled;
        });
    }

    getEmployeeStatus(employee) {
        if (employee) {
            if (employee.declined) {
                return this.angularFilterHelperService.translate('Employees.Invite_Declined');
            } else if (employee.pending) {
                return this.angularFilterHelperService.translate('Employees.Kombo_Import_Pending');
            } else if (employee.worker && employee.worker.active) {
                return this.angularFilterHelperService.translate('Employees.Active');
            } else if (employee.accepted && employee.worker && !employee.worker.active) {
                return this.angularFilterHelperService.translate('Employees.Deactive');
            } else {
                return this.angularFilterHelperService.translate('Employees.Invite_Pending');
            }
        } else {
            return "";
        }
    }

    showActiveOnly() {
        this.vm.loading = true;
        this.vm.employees = [];
        this.vm.currentPage = 0;
        this.vm.endReached = false;
        this.vm.isAllEmployeesModeEnabled = false;
        this.vm.fetchEmployees(true);
    }

    updateAllEmployeesModeEnabled() {
        this.vm.updateEmployeeListSelectionMap();
    }

    filterByName() {
        if (this.vm.term.trim().length === 0 || this.vm.term.trim().length > 1) {
            this.vm.loading = true;
            this.vm.employees = [];
            this.vm.currentPage = 0;
            this.vm.endReached = false;
            this.vm.fetchEmployees(true);
        }
    }

    setFilter(name) {
        this.vm.loading = true;
        this.vm.employees = [];
        this.vm.currentPage = 0;
        this.vm.endReached = false;

        this.vm.filter = this.vm.filter || {};
        this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
        this.vm.filter.orderBy = name;

        this.fetchEmployees(true);
    }

    openModalTrainingProgramDialog() {
        if (!this.vm.trainingProgramCode) {
            return;
        }
        var exceptionalEmployeeIds = Object
            .keys(this.vm.employeeSelectionMap)
            .filter((id) => {
                return this.vm.isAllEmployeesModeEnabled
                    ? this.vm.employeeSelectionMap[id] === false
                    : this.vm.employeeSelectionMap[id] === true
            });
        var dialog = this.dialogServices.show({
            controller: ModalTrainingProgramSelectionComponent,
            deselectNotActivated: this.vm.isShowActiveOnly,
            isAllEmployeesSelected: this.vm.isAllEmployeesModeEnabled,
            exceptionalEmployeeIds: exceptionalEmployeeIds,
            trainingProgramCode: this.vm.trainingProgramCode,
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: false
        });
        dialog.afterClosed().subscribe((data) => {
            if (data) {
                this.angularRoutingHelperService.setPath('/training-programs');
            }
        });
    }
}
